// extracted by mini-css-extract-plugin
module.exports = {"actionButtons":"index_actionButtons__2_1_c","cancelButton":"index_cancelButton__NXs1K"};